// extracted by mini-css-extract-plugin
export var alt = "PrivacyModal-module--alt--9eced";
export var desktopOnly = "PrivacyModal-module--desktopOnly--a659f";
export var main = "PrivacyModal-module--main--8a65e";
export var mobileOnly = "PrivacyModal-module--mobileOnly--76ac0";
export var styledDialog = "PrivacyModal-module--styledDialog--2d304";
export var textLeft = "PrivacyModal-module--textLeft--fb05d";
export var visuallyHidden = "PrivacyModal-module--visuallyHidden--06bd8";